import { useTheme } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { T_MANY } from '../../constants';
import { GroupChipElement } from '../group-chip-element';
import { ListPaperColumn } from '../list-item';

interface Props {
  'data-testid'?: string;
  hideLabel?: boolean;
  data: {
    groupIds: string[];
  };
}

export const GroupColumn: FC<Props> = ({ data, hideLabel, ...props }) => {
  const { t } = useTranslation(['common', 'track']);
  const theme = useTheme();

  return <ListPaperColumn
    data-testid={props['data-testid']}
    label={!hideLabel ? t('common:terms.group', { count: T_MANY }) : ''}
    sx={{ overflow: 'hidden' }}
    tooltipSlotProps={{
      arrow: {
        sx: {
          color: theme.palette.background.paper,
        },
      },
      tooltip: {
        sx: {
          background: theme.palette.background.paper,
          boxShadow: theme.shadows[6],
          '& .MuiBox-root': {
            background: theme.palette.background.paper,
          },
        },
      },
    }}
  >
    <GroupChipElement groupIds={data.groupIds} />
  </ListPaperColumn>;
};
